import { useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Util } from '../../api/util';
import MainMenu from './menu';
import Footer from './adminfooter';
import { Button, Modal, Table } from 'react-bootstrap';
import loadinglogo from '../../img/loading.gif';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { createPage } from '../tab/pagetab';
import { listsurveygroup, deletesurveygroup, duplicateSurveyGroup, listSurveyQuestion, listQuestionGroup, previewSurveyQuestion, listSurveyDashboard } from '../../store/surveygroup/actions';
import { queryclear } from '../../store/search/actions';
import { NOT_FOUND_LABEL } from '../../api/label';
import SurveyTab from './surveyTab';
import { SingleSearch } from '../tab/search-component';
import { SurveyDashboardItem } from '../../model/response/survey.model';
import PreviewQuestionModal from './previewQuestionModal';


type Props = {}

const SurveyDashboard = (props: Props) => {
  const [init, setInit] = useState(0)
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)
  const [totalItem, setTotalItem] = useState(0)
  const [totalPage, setTotalPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [items, setItem] = useState<Array<SurveyDashboardItem> | null>(null);
  const [error, setError] = useState('');
  const store = useStore();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      var res = store.getState().SearchReducer;
      if (res.isLoading) {
        setError('');
        setLoading(true);
      } else if (res.isLoaded) {
        setError('');
        setLoading(false);
        if (res.table === "list_survey_dashboard") {
          setInit(1);
          setItem(res.data.elements);
          setTotalPage(res.data.totalPages);
          setTotalItem(res.data.totalElements);

        } else {
          setError(NOT_FOUND_LABEL);
      }

      } else if (res.isNotFound) {
        setError(NOT_FOUND_LABEL);
        setItem([]);
        setLoading(false);
      } else if (res.isUpdated) {
        dispatch(queryclear);

      } else if (res.isFailed) {
        setError(res.data.message);
        setItem([]);
        setLoading(false);
      }
    });
    
    dispatch(listSurveyDashboard(page, limit));
    removeSession();
    window.scroll(0, 0);
    return unsubscribe;
  }, [])

  const removeSession = () => {
    sessionStorage.removeItem("searchDetails");
    sessionStorage.removeItem("searchPartnerDetails");
    sessionStorage.removeItem("searchSurveyDetails");
    sessionStorage.removeItem("searchTrainerDetails");
    sessionStorage.removeItem("searchManageQuestion");
    sessionStorage.removeItem("searchLogRequest");
    sessionStorage.removeItem("searchLogRequestHistory");
  }


  const handleLimit = (l: number) => {
    setLimit(l);
    setPage(0)
    dispatch(listSurveyDashboard(0, l));
  }

  const handlePage = (l: number) => {
    setPage(l);
    dispatch(listSurveyDashboard(l, limit));
  }

  const createBr = (n: number) => {
    var res: any[] = [];
    for (var j = 0; j < n; j++) {
      res.push(<br key={j + "br"} />);
    }
    return res;
  }

  return (<>
    <MainMenu>
      {(init === 1) &&
        <>
          <div>
            <div className="query-wrapper">
              <br />
              <div className="yellow-button" style={{ textAlign: "left", borderTopLeftRadius: "30px", borderTopRightRadius: "30px", height: "70px", paddingTop: "15px", paddingLeft: "15px" }}><h4 className="header">รายงาน / Dashboard</h4></div>
              <br />

              <br />
              <div className="row">
                <div className="col-5" style={{ justifyContent: "left", textAlign: "left", marginTop: "auto", marginBottom: "auto" }}>
                  จำนวนทั้งหมด {Util.integerWithCommas(totalItem)} รายการ
                </div>
                <div className="col-1">
                </div>
                <div className="col-6 row" style={{ justifyContent: "right", paddingRight: "0px" }}>
                  <div style={{ textAlign: "right", marginTop: "auto", marginBottom: "auto" }}>จำนวนรายการต่อหน้า</div>&nbsp;
                  <select className="form-control" style={{ width: "80px" }} name="page" value={limit} onChange={e => handleLimit(parseInt(e.target.value))}>
                    <option value="0">All</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>&nbsp;
                  
                </div>
              </div>
              {((!loading) && (items !== null) && (items !== undefined) && (items.length === 0) && (error === "")) &&
                <><br /><br /><div className="text-center">{NOT_FOUND_LABEL}</div></>
              }
              {(error !== "") &&
                <div style={{ color: 'red', textAlign: "center" }}>{error}</div>
              }
              {((items !== null) && (items !== undefined) && (items.length >= 1)) &&
                <>
                  <br />
                  <Table striped hover>
                    <thead className="black-button">
                      <tr>
                        <th className='text-left'>ชื่อแบบประเมินผลที่แสดง</th>
                        <th className='text-left'>Power BI URL</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize:"23px" }}>
                      {items.map((item, index) => {
                        return <tr key={item.surveyGroupId + "_table_list"}>
                          <td className='text-left'> {item.surveyGroupNickname} </td>
                          <td className="text-left">
                            <a href={item.powerBiUrl} target="_blank" rel="noopener noreferrer">
                              View
                            </a>
                          </td>
                        </tr>
                      })}
                    </tbody>
                  </Table>
                  <br />

                  <div className="row" style={{ justifyContent: "center", position: "relative" }}>
                    {createPage(page, totalPage, handlePage)}
                    <div className="col-5" style={{ justifyContent: "left", textAlign: "left", position: "absolute", left: "0px" }}>
                      จำนวนทั้งหมด {Util.integerWithCommas(totalItem)} รายการ
                    </div>
                  </div>
                </>
              }
              <br />
              <br />

              {((items === null) || (items === undefined) || (items.length < 5)) &&
                <>{createBr(((items === null) || (items === undefined)) ? 8 : 8 - items.length)}
                </>
              }
            </div>
            <Footer empty={((items === null) || (items === undefined) || (items.length === 0))} />
          </div></>
      }
      {(init < 1) &&
        <>
          {(error === "") &&
            <div style={{ textAlign: "center", width: "1200px" }}><img src={loadinglogo} width="30" height="30" className="d-inline-block align-top" alt="" /></div>
          }
          {(error !== "") &&
            <div style={{ color: 'red', textAlign: "center" }}>{error}</div>
          }
        </>
      }
    </MainMenu>
   
  </>
  )
}

export default SurveyDashboard